import "./slider.css";
import { Slider } from './slider';
export default Slider;